/**
 * 日志打印
 */
import utils from './utils';

const logger =  (function (utils) {
    var logger;
    if (!!utils.isDebug) {
        logger = console;
    }
    else {
        logger = {
            log: function () {
            },
            info: function () {
            },
            error: function () {
            },
            warn: function () {
            }
        };
    }

    return logger;
})(utils);

export default logger;


// WEBPACK FOOTER //
// ./src/common/js/logger.js